export default {
    key: 'employee-skipass',
    common: {
        productName: 'core.productNames.employee-skipass',
        splashMessage: 'offerFlow.splashMessage.employee-skipass',
        headingAside: 'offerFlow.headingAside.employee-skipass',
    },
    stepDate: {
        heading: 'offerFlow.pages.stepDate.heading.employee-skipass',
    },
    stepPassengers: {
        heading: 'offerFlow.pages.stepPassengers.heading.employee-skipass',
        body: 'offerFlow.pages.stepPassengers.body.withReductions',
    },
} satisfies OfferFlowContent;
